import { ConversionCreditBanner } from 'components/conversionCredit/ConversionCreditBanner';
import { ReferralBanner } from 'components/referral/ReferralBanner';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useSportContext } from 'contexts/sport';
import { useConversionCredit } from 'hooks/useConversionCredit';
import useLifecycle from 'hooks/useLifecycle';

export const Banners = () => {
  const { currentUser } = useCurrentUserContext();
  const { sport } = useSportContext();
  const conversionCredit = useConversionCredit(sport);
  const { lifecycle } = useLifecycle();

  const referralBannerHidden =
    !currentUser ||
    lifecycle?.hideReferralBanner ||
    currentUser.referralRewardsCount > 0;
  const conversionCreditBannerHidden =
    currentUser?.userSettings?.hideBalance || !conversionCredit;

  if (referralBannerHidden && conversionCreditBannerHidden) {
    return null;
  }

  if (!(currentUser?.userSettings?.hideBalance || !conversionCredit)) {
    return <ConversionCreditBanner />;
  }
  if (sport) {
    return <ReferralBanner sport={sport} />;
  }
  return null;
};
